export default {
  login: 'ログイン',
  logout: 'ログアウト',
  username: 'ユーザー名',
  password: 'パスワード',
  rememberMe: 'ログイン情報を保存',
  forgotPassword: 'パスワードをお忘れですか？',
  loginSuccess: 'ログインしました',
  loginFailed: 'ログインに失敗しました',
  unauthorized: '認証されていません。再度ログインしてください',
  forbidden: '権限が不足しています',
};
